function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "user_people_person_users_man",
  "data-name": "user people person users man",
  transform: "translate(-5 -3)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_4196",
  "data-name": "Path 4196",
  d: "M18.345,16.1a.713.713,0,1,0-1,1.011,6.409,6.409,0,0,1,1.9,4.558c0,.869-2.5,2.136-6.409,2.136s-6.409-1.268-6.409-2.136A6.409,6.409,0,0,1,8.3,17.129a.71.71,0,0,0-1-1A7.776,7.776,0,0,0,5,21.665c0,2.314,4.038,3.561,7.833,3.561s7.833-1.246,7.833-3.561A7.791,7.791,0,0,0,18.345,16.1Z",
  transform: "translate(0 -3.711)",
  fill: "#f6c244"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_4197",
  "data-name": "Path 4197",
  d: "M13.985,12.97A4.985,4.985,0,1,0,9,7.985,4.985,4.985,0,0,0,13.985,12.97Zm0-8.545a3.561,3.561,0,1,1-3.561,3.561A3.561,3.561,0,0,1,13.985,4.424Z",
  transform: "translate(-1.152)",
  fill: "#f6c244"
}));

var SvgUser = function SvgUser(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15.667,
    height: 18.515,
    viewBox: "0 0 15.667 18.515",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgUser, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/user.dbc4cf07.svg";
export { ForwardRef as ReactComponent };